import ClientGateway from '../gateway/ClientGateway';

this.execute = (callback) => {
    ClientGateway.getAll(callback);
}

export default { execute: this.execute }


// WEBPACK FOOTER //
// ./src/usecase/ListClients.js